import React from 'react';

type State = { hasError: boolean; info?: string };

export class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };
  static getDerivedStateFromError() { return { hasError: true }; }
  componentDidCatch(error: any, info: any) {
    // Optional: send to your logger
    this.setState({ info: String(error) });
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ border: '1px solid #e6e8eb', borderRadius: 12, padding: 16, background: '#fff' }}>
          <h6 style={{ margin: 0 }}>Something went wrong.</h6>
          <div style={{ fontSize: 12, color: '#6b7280', marginTop: 6 }}>
            Try refreshing, or switch back to the original page while we refine this version.
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
